export default {
      id: "log-out-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#log-out",
      toString: function () {
        return this.url;
      }
    }